import DashboardPage from "../components/DashboardPage";

export default function Home() {
  return <DashboardPage currentTab="deployments" />;
}
